import { Component } from '@angular/core';

@Component({
    selector: 'app-transloco-spinner',
    template: '<div [tslSpinner]="true" style="min-height: 400px; height: 100%"></div>',
})
export class TranslocoSpinnerComponent {
    constructor() {}
}
